import { Field, FieldError, FieldLabel } from "@/client/components/shad/field";
import { useFieldContext } from "../form-context";
import { useId } from "react";
import { Switch } from "@/client/components/shad/switch";

type Props = {
  falseLabel: string;
  trueLabel: string;
};

export function SwitchField({ falseLabel, trueLabel }: Props) {
  const id = useId();
  const field = useFieldContext<boolean>();
  const isInvalid = field.state.meta.isTouched && !field.state.meta.isValid;

  return (
    <Field>
      <div className="inline-flex items-center gap-2">
        <Switch
          aria-label="Toggle switch"
          checked={field.state.value}
          id={id}
          onCheckedChange={field.handleChange}
        />
        <FieldLabel className="font-medium text-sm" htmlFor={id}>
          {field.state.value ? trueLabel : falseLabel}
        </FieldLabel>
      </div>
      {isInvalid && (
        <FieldError className="text-xs" errors={field.state.meta.errors} />
      )}
    </Field>
  );
}
